import {
  Box,
  ButtonBase,
  Card,
  CircularProgress,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import CompactMetric from './Components/CompactMetric'
import FitnessRings from './Components/FitnessRings'
import { FITNESS_METRICS, formatTimeRemaining } from './Utils/utils'
import { useFitnessTrackerContext } from './Context/FitnessTrackerContext'
import { useTimeRemaining } from './Hooks/useTimeRemaining'

export default function CompactDashboard() {
  const { stats, currentHour, error, setExpanded } = useFitnessTrackerContext()
  const timeRemaining = useTimeRemaining()

  if (error) {
    return (
      <Card sx={{ p: 3 }}>
        <Typography color="text.secondary">
          Unable to load fitness data.
        </Typography>
      </Card>
    )
  }

  if (!stats || !currentHour) {
    return (
      <Card sx={{ p: 3 }}>
        <CircularProgress size={24} />
      </Card>
    )
  }

  return (
    <Card
      sx={{
        width: '100%',
        p: 3,
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderRadius: 4,
      }}
    >
      <Box display="flex" justifyContent="space-between" mb={3}>
        <Typography variant="body2">THIS HOUR ({currentHour.hour})</Typography>

        <Typography variant="body2">
          Resets in {formatTimeRemaining(timeRemaining)}
        </Typography>
      </Box>

      <Box display="flex" justifyContent="center" mb={3}>
        <Box sx={{ maxWidth: '120px' }}>
          <FitnessRings stats={currentHour} />
        </Box>
      </Box>

      {Object.entries(FITNESS_METRICS).map(([key, { label, colour }]) => (
        <CompactMetric
          key={key}
          label={label}
          data={currentHour[key]}
          colour={colour}
        />
      ))}
      <Box display="flex" justifyContent="center">
        <ButtonBase
          onClick={() => setExpanded(true)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          Expand
          <ExpandMoreIcon fontSize="small" />
        </ButtonBase>
      </Box>
    </Card>
  )
}
